import React, { Fragment,  useEffect } from "react";
import { get, toLower } from "lodash";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
import InputFieldWithButton from "Components/formControls/HookFields/InputFieldWithButton";
import { Box, Button, Typography } from "@material-ui/core";
import { AddCircle, AddCircleOutline } from "@material-ui/icons";
// import Chips from "Components/formControls/Chips";
import { checkArrayLength } from "src/utils";
import useStyles from "../styles";
import NoChip from "Components/widgets/NoData/NoChip";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import AllTargetsChips from "Components/formControls/HookFields/Chip/AllTargetsChips";

const Titles = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    watch,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useFormContext();
  const { configuration, disabledView } = watch();

  const { organizationTitleNameError } = useOrganizationValidation();

  const condition = [...configuration.title.titles]
    .map((res) => toLower(res))
    .includes(toLower(configuration?.title?.name?.trimLeft()));

  useEffect(() => {
    if (checkArrayLength(configuration.title.titles)) {
      clearErrors("configuration.title");
    }
  }, [checkArrayLength(configuration.title.titles)]);

  const addTitle = () => {
    if (condition) return;
    if (configuration?.title?.name?.trimLeft()) {
      const newArr = [...configuration.title.titles, configuration.title.name];
      setValue("configuration.title.titles", newArr);
      setValue("configuration.title.name", "");
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      addTitle();
    }
  };

  const handleRemoveChip = (res) => {
    setValue(
      "configuration.title.titles",
      configuration?.title?.titles.filter(
        (item) => item == "Admin" || item !== res
      )
    );
  };

  return (
    <Fragment>
      <Typography variant="body2" className="font-semibold w-100 ">
        {t("companySetup.config.titles.label")}
      </Typography>
      <Box className={classes.wrapperCard}>
        <SimpleBar
          forceVisible="y"
          style={{ height: "100%" }}
          data-simplebar-auto-hide="false"
        >
          <Box p={1.5}>
            <InputFieldWithButton
              register={register(
                "configuration.title.name"
                // organizationTitleNameError
              )}
              name="configuration.title.name"
              error={
                get(errors, "configuration.title.message") ||
                get(errors, "configuration.title.name.message")
              }
              disabled={disabledView}
              // label={t("companySetup.config.titles.label")}
              placeholder={t("companySetup.config.titles.placeholder")}
              onKeyDown={(e) => handleKeyDown(e)}
            >
              <Button
                size="small"
                data-testId="all"
                onClick={() => addTitle()}
                disabled={condition || disabledView}
              >
                {configuration?.title?.name ? (
                  <AddCircle color="primary" />
                ) : (
                  <AddCircleOutline color="primary" />
                )}
              </Button>
            </InputFieldWithButton>

            <Box mt={1} display="flex" flexWrap="wrap">
              {checkArrayLength(configuration?.title?.titles) ? (
                <AllTargetsChips
                  allTargets={
                    [...configuration?.title?.titles].sort(
                      Intl.Collator().compare
                    ) || []
                  }
                  handleRemoveChip={disabledView ? "" : handleRemoveChip}
                  itemsNo={15}
                />
              ) : (
                <NoChip name={"titles"} />
              )}
            </Box>
          </Box>
        </SimpleBar>
      </Box>
    </Fragment>
  );
};

export default Titles;
